<template>
    <div class="jobOfferInfo">
        <div class="offer" v-if="jobOtherInfo && jobOtherInfo.JobType == 6 && jobOtherInfo.IsProjectJob == 1">
            <h3 class="pool-min-title">上游报价</h3>
            <el-table :data="jobUpOfferList" border style="width: 100%" :header-cell-style="{ background: '#F5F7FA' }"
                highlight-current-row @current-change="handleUpChange" ref="upTable">
                <el-table-column prop="BatchNum" label="选择" align="center" show-overflow-tooltip v-if="isAudit">
                    <template slot-scope="scope" v-if="scope.row.AuditStatus == 0">
                        <i class="el-icon-circle-check" v-if="selectUpOffer && selectUpOffer.Id == scope.row.Id"></i>
                        <span class="noselect" v-else></span>
                    </template>
                </el-table-column>
                <el-table-column prop="BatchNum" label="编号" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ManHourAmount" label="人工费" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.ManHourAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="TrafficAmount" label="交通费" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.TrafficAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="MateriaAmount" label="材料费" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.MateriaAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="OtherAmount" label="其他费用" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.OtherAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="计费类型" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.BillType == 0 ? "按天" : "整包" }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="TotalAmount" label="总费用" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.TotalAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="AdminUserName" label="报价人" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="状态" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.AuditStatus == 1" style="color: blue;">{{ scope.row.AuditStatusName
                        }}</span>
                        <span v-else-if="scope.row.AuditStatus == 2" style="color: red;">{{ scope.row.AuditStatusName
                        }}</span>
                        <span v-else>{{ scope.row.AuditStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="scope">
                        <el-button type="text" size="medium" @click="jobUpQuotedPriceDetail(scope.row)">详情</el-button>
                        <el-button type="text" size="medium"
                            v-if="scope.row.AuditStatus == 1 || scope.row.AuditStatus == 3"
                            @click="jobUpQuotedPriceSucDetail(scope.row)">报价单</el-button>

                        <!-- <el-button type="text" size="medium"
                            @click="getJobApplyOrderInfo(scope.row.ApplyOrderId)">查看详情</el-button>
                        <el-button type="text" v-if="scope.row.AccountType == 1" size="medium"
                            @click="getServiceAbility(scope.row.AccountId)">编辑服务能力</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="offer" v-if="jobOtherInfo && jobOtherInfo.JobType == 6">
            <h3 class="pool-min-title">下游报价</h3>
            <el-table :data="jobDownOfferList" border style="width: 100%" :header-cell-style="{ background: '#F5F7FA' }"
                highlight-current-row @current-change="handleDownChange" ref="downTable">
                <el-table-column prop="BatchNum" label="选择" align="center" show-overflow-tooltip v-if="isAudit">
                    <template slot-scope="scope" v-if="scope.row.AuditStatus == 0">
                        <i class="el-icon-circle-check"
                            v-if="selectDownOffer && selectDownOffer.Id == scope.row.Id && scope.row.AuditStatus == 0"></i>
                        <span class="noselect" v-else></span>
                    </template>
                </el-table-column>
                <el-table-column prop="BatchNum" label="报价批次" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ReceiverUserName" label="姓名" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="ManHourAmount" label="人工费" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.ManHourAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="TrafficAmount" label="交通费" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.TrafficAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="MateriaAmount" label="材料费" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.MateriaAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="OtherAmount" label="其他费用" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.OtherAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="计费类型" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.BillType == 0 ? "按天" : "整包" }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="TotalAmount" label="总费用" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>￥{{ scope.row.TotalAmount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="NoTaxProfitRate" label="不含税利润率" width="110" align="center"
                    v-if="this.jobOtherInfo.IsProjectJob == 0" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.NoTaxProfitRate }}%</span>
                    </template>
                </el-table-column>
                <el-table-column prop="AdminUserName" label="报价人" align="center" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="状态" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.AuditStatus == 1" style="color: blue;">{{ scope.row.AuditStatusName
                        }}</span>
                        <span v-else-if="scope.row.AuditStatus == 2" style="color: red;">{{ scope.row.AuditStatusName
                        }}</span>
                        <span v-else>{{ scope.row.AuditStatusName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="180">
                    <template slot-scope="scope">
                        <el-button type="text" size="medium" @click="jobDownQuotedPriceDetail(scope.row)">详情</el-button>
                        <el-button type="text" size="medium"
                            v-if="scope.row.AuditStatus == 1 || scope.row.AuditStatus == 3"
                            @click="jobDownQuotedPriceSucDetail(scope.row)">报价单</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="height: 50px; padding:10px 0px;">
                <span style=""
                    v-if="this.selectUpOffer && this.selectDownOffer && this.jobOtherInfo.IsProjectJob == 1 && selectOfferRateMsg">{{
                        selectOfferRateMsg }}</span>
            </div>
        </div>
        <div class="btn" v-if="isAudit"> 
            <el-button type="primary" size="small" @click="audit(1)">审核通过</el-button>
            <el-button type="danger" size="small" @click="audit(0)" style="margin-left: 120px;">审核拒绝</el-button>
        </div>
        <!-- 上游报价详情弹窗 -->
        <jobUpQuotedPriceDetailDialog ref="jobUpQuotedPriceDetailDialogRef" />
        <!-- 下游报价详情弹窗 -->
        <jobDownQuotedPriceDetailDialog ref="jobDownQuotedPriceDetailDialogRef" />
        <!-- 审核弹窗 -->
        <jobOfferPriceAuditDialog ref="jobOfferPriceAuditDialogRef" @reloadJobDetail="$emit('reloadJobDetail')" />
        <!-- 上游成功报价单弹窗 -->
        <jobUpQuotedPriceSucDetailDialog ref="jobUpQuotedPriceSucDetailDialogRef" />
        <!-- 下游成功报价单弹窗 -->
        <jobDownQuotedPriceSucDetailDialog ref="jobDownQuotedPriceSucDetailDialogRef" />
    </div>
</template>

<script>
import { GetJobOfferPrice, GetJobOfferRate } from "@/service/job";

import jobDownQuotedPriceDetailDialog from './jobDownQuotedPriceDetailDialog.vue'
import jobUpQuotedPriceDetailDialog from './jobUpQuotedPriceDetailDialog.vue'
import jobOfferPriceAuditDialog from './jobOfferPriceAuditDialog.vue'
import jobUpQuotedPriceSucDetailDialog from './jobUpQuotedPriceSucDetailDialog.vue'
import jobDownQuotedPriceSucDetailDialog from './jobDownQuotedPriceSucDetailDialog.vue'

export default {
    components: {
        jobDownQuotedPriceDetailDialog,
        jobUpQuotedPriceDetailDialog,
        jobOfferPriceAuditDialog,
        jobUpQuotedPriceSucDetailDialog,
        jobDownQuotedPriceSucDetailDialog
    },
    data() {
        return {
            jobId: 0,

            jobOtherInfo: null,
            jobBaseInfo: null,
            jobDetailInfo: null,

            jobUpOfferList: null,
            jobDownOfferList: null,
            isAudit: false,

            selectUpOffer: null,
            selectDownOffer: null,
            selectOfferRateMsg: ''
        };
    },
    created() {

    },
    methods: {
        getJobOfferList(jobData) {
            this.jobId = this.$route.query.JobId;

            this.jobOtherInfo = jobData.JobOtherInfo;
            this.jobBaseInfo = jobData.JobBaseInfo;
            this.jobDetailInfo = jobData.JobDetailInfo;
            this.selectOfferRateMsg = '';
            GetJobOfferPrice({ JobId: this.jobId }).then((res) => {
                // console.log('GetJobOfferPrice:' + JSON.stringify(res));
                if (res.Result == 1) {
                    this.jobUpOfferList = res.Data.JobUpOfferList;
                    this.jobDownOfferList = res.Data.JobDownOfferList;
                    this.isAudit = res.Data.IsAudit;
                }
            });
        },
        jobUpQuotedPriceDetail(info) {
            this.$refs.jobUpQuotedPriceDetailDialogRef.openDia(info);
        },
        jobDownQuotedPriceDetail(info) {
            this.$refs.jobDownQuotedPriceDetailDialogRef.openDia(info, this.jobOtherInfo.IsProjectJob);
        },
        //上游报价成功单
        jobUpQuotedPriceSucDetail(info) {
            this.$refs.jobUpQuotedPriceSucDetailDialogRef.openDia(info, this.jobOtherInfo, this.jobBaseInfo, this.jobDetailInfo);
        },
        //下游报价成功单
        jobDownQuotedPriceSucDetail(info) {
            this.$refs.jobDownQuotedPriceSucDetailDialogRef.openDia(info, this.jobOtherInfo, this.jobBaseInfo, this.jobDetailInfo);
        },
        handleUpChange(val) {
            if (val) {
                // console.log('handleUpChange:' + JSON.stringify(val))
                if (val.AuditStatus == 0) {
                    // this.$message.warning('请选择【待审核】的报价');
                    this.$refs.upTable.setCurrentRow(val);
                    this.selectUpOffer = val;
                }
                else {
                    this.selectUpOffer = null;
                    this.$refs.upTable.setCurrentRow(null);
                }

                if (this.jobOtherInfo.IsProjectJob == 1) {
                    this.getJobOfferRate();
                }

            }
        },
        handleDownChange(val) {
            if (val) {
                if (val.AuditStatus == 0) {
                    // this.$message.warning('请选择【待审核】的报价');
                    this.$refs.downTable.setCurrentRow(val);
                    this.selectDownOffer = val;
                }
                else {
                    this.selectDownOffer = null;
                    this.$refs.downTable.setCurrentRow(null);
                }

                // console.log('this.selectDownOffer:' + JSON.stringify(this.selectDownOffer));

                if (this.jobOtherInfo.IsProjectJob == 1) {
                    this.getJobOfferRate();
                }
            }
        },
        //审核
        audit(isPass) {
            if (isPass == 1) {
                var upOfferId = 0;
                if (this.jobOtherInfo.IsProjectJob == 1) {
                    if (!this.selectUpOffer) {
                        return this.$message.warning('请选择1个要审核通过的上游报价');
                    }
                    upOfferId = this.selectUpOffer.Id;
                }
                if (!this.selectDownOffer) {
                    return this.$message.warning('请选择1个要审核通过的下游报价');
                }
                this.$refs.jobOfferPriceAuditDialogRef.openDia(this.jobId,
                    1,
                    upOfferId,
                    this.selectDownOffer.Id);
            }
            else {
                var upOfferId = 0;
                if (this.selectUpOffer) {
                    upOfferId = this.selectUpOffer.Id;
                    // return this.$message.warning('请选择1个要审核通过的上游报价');
                }
                var downOfferId = 0;
                if (this.selectDownOffer) {
                    downOfferId = this.selectDownOffer.Id;
                    // return this.$message.warning('请选择1个要审核通过的上游报价');
                }
                if (downOfferId <= 0 && upOfferId <= 0) {
                    return this.$message.warning('请选择要拒绝的报价');
                }
                this.$refs.jobOfferPriceAuditDialogRef.openDia(this.jobId, 0, upOfferId, downOfferId);
            }
        },
        //获取所选报价的利润率
        getJobOfferRate() {
            console.log('getJobOfferRate触发');
            if (this.selectUpOffer && this.selectDownOffer) {
                var data = {
                    JobId: this.jobId,
                    JobUpOfferId: this.selectUpOffer.Id,
                    JobDownOfferId: this.selectDownOffer.Id
                };
                this.selectOfferRateMsg = '';
                GetJobOfferRate(data).then((res) => {
                    console.log('res:' + JSON.stringify(res))
                    if (res.Result == 0) {
                        return this.$message.error(res.Message);
                    }
                    this.selectOfferRateMsg = `上游编号${this.selectUpOffer.BatchNum}报价与下游${this.selectDownOffer.ReceiverUserName}的报价利润率为${res.Data}%`;
                });

            }
        }
    }
}
</script>

<style scoped lang="scss">
.jobOfferInfo {
    padding: 10px;

    .pool-min-title {
        margin-bottom: 10px;
    }

    .offer {
        margin-bottom: 15px;
    }

    i.el-icon-circle-check {
        font-size: 24px;
        cursor: pointer;
        color: #66b1ff;
    }

    span.noselect {
        display: block;
        height: 18px;
        width: 18px;
        border: 1px solid #999999;
        border-radius: 9px;
        margin: auto;

    }

    .btn {
        text-align: center;
        padding-top: 0px;
    }
}
</style>